import React, { useEffect, useState } from "react";
import VoucherCard from "../VoucherCard/VoucherCard";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getUserVouchers, unsubscribe,  userLogout ,
} from "../../Utilies/gamerClubApi";
import LibyaService , { updateSubscriptionStorage } from "../../Utilies/Utilies/libyaService";
import "./MySubscription.css"
import { notify1 } from "../ToastComponent";
import { useNavigate } from "react-router-dom";

import { notify } from "../ToastComponent";
import { ToastContainer } from "react-toastify";
import { Modal, Button, Form } from 'react-bootstrap'; 

import LogoutConfirmationModal from "./UnsubscribeModal"; // Import the modal component


const Subscription = ({ toggle , userDetails, details }) => {
             const isLibyad = window.location.hostname.includes("libyad") || window.location.hostname.includes("localhost") || window.location.hostname.includes("gamerclub.ly");
     const isLebara = window.location.hostname.includes("lebara");
 const canCancel = Boolean(details?.data?.can_cancel);
 // const canCancel = false;

    const subscriptionDateSource = isLebara
      ? userDetails?.created_at || userDetails?.subscription_date
      : userDetails?.subscription_date;
    const subscriptionDate = new Date(subscriptionDateSource);
    const formattedDate = Number.isNaN(subscriptionDate.getTime())
      ? "-"
      : `${subscriptionDate.getFullYear()}-${subscriptionDate.getMonth() + 1}-${subscriptionDate.getDate()}`;


  
  const { t } = useTranslation();
  const [userSub, setUserSub] = useState([]);
  // get user token
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [isUnsubscribeModalOpen, setIsUnsubscribeModalOpen] = useState(false);
const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
const [otp, setOtp] = useState("");
const [loading, setLoading] = useState(false);
const [isChangePackageModalOpen, setIsChangePackageModalOpen] = useState(false);
const [changePackageStep, setChangePackageStep] = useState("list");
const [packages, setPackages] = useState([]);
const [packagesLoading, setPackagesLoading] = useState(false);
const [selectedPackageUuid, setSelectedPackageUuid] = useState("");
const [upgradeOtp, setUpgradeOtp] = useState("");

const getLibyaPhone = () =>
  localStorage.getItem("msisdn") || "";

const normalizePackages = (responseData) => {
  const raw =
    responseData?.data ??
    responseData?.packages ??
    responseData ??
    [];

  return Array.isArray(raw) ? raw : [];
};

const getPackageLabel = (pkg) =>
  pkg?.name ||
  pkg?.title ||
  pkg?.package_name ||
  pkg?.label ||
  pkg?.description ||
  pkg?.uuid ||
  t("Select a package");

const getPackagePrice = (pkg) =>
  pkg?.price || pkg?.cost || pkg?.amount || pkg?.fee || "";

const getPackageDisplayName = (pkg) => {
  const period = pkg?.period;
  const productId = pkg?.product_id;
  const name = (pkg?.name || "").toLowerCase();

  if (period === 168 || productId === 2 || name.includes("أسبوع") || name.includes("week")) {
    return t("Weekly plan");
  }

  if (period === 720 || productId === 3 || name.includes("شهر") || name.includes("month")) {
    return t("Monthly plan");
  }

  if (period === 24 || productId === 1 || name.includes("يوم") || name.includes("day")) {
    return t("Daily plan");
  }

  return getPackageLabel(pkg);
};

const getCurrentPlanUuid = (packagesList, subscriptionDetails) => {
  const data = subscriptionDetails?.data;
  if (!data || !packagesList?.length) return "";

  const directUuid = data.uuid || data.subscription_uuid;
  if (directUuid) {
    const match = packagesList.find(
      (pkg) => (pkg?.uuid || pkg?.id) === directUuid
    );
    if (match) return directUuid;
  }

  const currentName = (data.subscription_name || "").trim().toLowerCase();
  if (currentName) {
    const matchByName = packagesList.find((pkg) => {
      const pkgName = (pkg?.name || "").trim().toLowerCase();
      return (
        pkgName === currentName ||
        pkgName.includes(currentName) ||
        currentName.includes(pkgName)
      );
    });
    if (matchByName) return matchByName.uuid || matchByName.id;
  }

  if (data.product_id) {
    const matchByProduct = packagesList.find(
      (pkg) => pkg?.product_id === data.product_id
    );
    if (matchByProduct) return matchByProduct.uuid || matchByProduct.id;
  }

  if (currentName.includes("أسبوع") || currentName.includes("week")) {
    const weeklyPlan = packagesList.find(
      (pkg) => pkg?.period === 168 || pkg?.product_id === 2
    );
    if (weeklyPlan) return weeklyPlan.uuid || weeklyPlan.id;
  }

  if (currentName.includes("شهر") || currentName.includes("month")) {
    const monthlyPlan = packagesList.find(
      (pkg) => pkg?.period === 720 || pkg?.product_id === 3
    );
    if (monthlyPlan) return monthlyPlan.uuid || monthlyPlan.id;
  }

  if (currentName.includes("يوم") || currentName.includes("day")) {
    const dailyPlan = packagesList.find(
      (pkg) => pkg?.period === 24 || pkg?.product_id === 1
    );
    if (dailyPlan) return dailyPlan.uuid || dailyPlan.id;
  }

  return "";
};

const getPackageOptionLabel = (pkg) => {
  const label = getPackageDisplayName(pkg);
  const price = getPackagePrice(pkg);
  return price ? `${label} - ${price}` : label;
};

const fetchSubscriptionPackages = async () => {
  const phone = getLibyaPhone();
  if (!phone) {
    notify1(t("Something went wrong"));
    return;
  }

  try {
    setPackagesLoading(true);
    const res = await LibyaService.getSubscriptionList(phone);

    if (res?.data?.success === false) {
      notify1(res?.data?.message || t("Failed to load packages"));
      setPackages([]);
      return;
    }

    const loadedPackages = normalizePackages(res?.data);
    setPackages(loadedPackages);
    setSelectedPackageUuid(getCurrentPlanUuid(loadedPackages, details));
  } catch (err) {
    notify1(
      err?.response?.data?.message || t("Failed to load packages")
    );
    setPackages([]);
  } finally {
    setPackagesLoading(false);
  }
};

const resetChangePackageModal = () => {
  setIsChangePackageModalOpen(false);
  setChangePackageStep("list");
  setPackages([]);
  setSelectedPackageUuid("");
  setUpgradeOtp("");
};

const handleChangePackageClick = async () => {
  setChangePackageStep("list");
  setUpgradeOtp("");
  setIsChangePackageModalOpen(true);
  await fetchSubscriptionPackages();
};

const handlePackageUpgrade = async () => {
  if (!selectedPackageUuid) return;

  const currentPlanUuid = getCurrentPlanUuid(packages, details);
  if (selectedPackageUuid === currentPlanUuid) {
    notify1(t("You are already subscribed"));
    return;
  }

  try {
    setLoading(true);
    const res = await LibyaService.upgradePackage({
      phone: getLibyaPhone(),
      uuid: selectedPackageUuid,
    });

    if (res?.data?.success === true) {
      setChangePackageStep("otp");
    } else {
      notify1(res?.data?.message || t("Failed to change package"));
    }
  } catch (err) {
    notify1(
      err?.response?.data?.message || t("Failed to change package")
    );
  } finally {
    setLoading(false);
  }
};

const handleUpgradeConfirm = async () => {
  if (!upgradeOtp || !selectedPackageUuid) return;

  try {
    setLoading(true);
    const res = await LibyaService.upgradeConfirm({
      phone: getLibyaPhone(),
      otp: upgradeOtp,
      uuid: selectedPackageUuid,
    });

    if (res?.data?.success === true) {
      notify(t("Package changed successfully"));
      resetChangePackageModal();

      try {
        const subRes = await LibyaService.getSubDetails();
        if (subRes?.data?.data) {
          updateSubscriptionStorage(subRes.data.data);
        }
      } catch (e) {
        console.error("Failed to fetch updated subscription details:", e);
      }
    } else {
      notify1(res?.data?.message || t("Failed to change package"));
    }
  } catch (err) {
    notify1(
      err?.response?.data?.message || t("Failed to change package")
    );
  } finally {
    setLoading(false);
  }
};

  async function userSubs(token) {
    try {
        let result = await getUserVouchers(token);
      setUserSub(result.data);
    } catch (error) {}
  }
  const unsubscribeCall = async () => {
    try {


    await unsubscribe(token);
        notify("unsubscribed Successfully!");
        console.log(token)
        // handleConfirmLogout()
            try {
              await userLogout(token);
              localStorage.clear();
              navigate("/signIn", { replace: true });
            } catch (error) {
              console.log(error);
            }
          
        
     
    } catch (err) {
      notify1(err.response.data.error);
    }
  };


    const [showModal, setShowModal] = useState(false);
  
    // Function to handle showing the modal
    const handleLogoutClick = () => {
      setShowModal(true);
    };
    // Function to handle confirmation
    const handleConfirmLogout = () => {
        setShowModal(false);
        console.log('User confirmed logout');
        // Add your logout logic here
        unsubscribeCall()
      };
 // Function to handle closing the modal
 const handleCloseModal = () => {
    setShowModal(false);

    
  };    

  useEffect(() => {
    userSubs(token);
  }, [token]);
const handleUnsubscribe = () => {
  console.log("Unsubscribe clicked");
  setIsUnsubscribeModalOpen(true);
};
const confirmUnsubscribe = async () => {
  try {
    setLoading(true);
    const response = await unsubscribe(token);
    if (response?.success !== true) {
      notify1(response?.message || t("Unsubscribe failed"));
      setIsUnsubscribeModalOpen(false);
      return;
    }
    else{
      setIsUnsubscribeModalOpen(false);
      notify(t("Unsubscribed successfully"));
      try {
        const res = await LibyaService.getSubDetails();
        if (res?.data?.data) {
          updateSubscriptionStorage(res.data.data);
        }
      } catch (e) {
        console.error("Failed to fetch updated subscription details:", e);
      }
      setTimeout(() => {
        navigate("/");
      }, 1000);
    }
    
  } catch (err) {
    console.error(err);
    notify1(err?.response?.data?.message || t("Unsubscribe failed"));
  } finally {
    setLoading(false);
  }
};
const handleSubscribe = async () => {
  try {
    setLoading(true);

    const res = await LibyaService.activateSubscriptionApi({
      phone: userDetails.phone,
    });

    // ✅ CHECK RESPONSE
    if (res?.data?.success === true) {
      setIsOtpModalOpen(true);
    } else {
      notify1(res?.data?.message || t("Something went wrong"));
    }
  } catch (err) {
    notify1(
      err?.response?.data?.message || t("Server error, please try again")
    );
  } finally {
    setLoading(false);
  }
};

const verifyOtp = async () => {
  try {
    setLoading(true);

    const res = await LibyaService.verifyOtpApi({
      phone: userDetails.phone,
      otp,
    });

    // ✅ CHECK RESPONSE
    if (res?.data?.success === true) {
      setIsOtpModalOpen(false);
      setOtp("");
      notify(t("Subscription activated successfully"));
    navigate("/", );
    } else {
      notify1(res?.data?.message || t("Invalid OTP"));
    }
  } catch (err) {
    notify1(
      err?.response?.data?.message || t("Verification failed")
    );
  } finally {
    setLoading(false);
  }
};
 const allowOnlyNumbers = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <div className={toggle === 5? "show-content game-voucher" : "content"}>

<div className="list-content game-row show-content game-history">
      <ToastContainer />
{isLibyad ? (
  <Row className="my-3 wishlist">

      {details?.data?.created_at && (

            <Col xs={12} md={12} lg={12} xxl={12} className="mb-3">
         <span>  {t("subscription date")}
            </span>  : { details?.data?.expiration_date.split(" ")[0]?? "-"}
            <br></br>
           {/*  <span>     {t("renewal date")} </span>: { details?.data?.expiration_date.split(" ")[0]?? "-" } 
            <br></br> */}
<span>
  {t("subscription status")}:{" "}
  <strong style={{ color: details?.data?.status  === "active" ? "green" : "red" }}>
    {details?.data?.status  === "active" ? t("Active") : t("Inactive")}
  </strong>
</span>

        <br></br>
        <span> {t("subscribed number")}</span>    :{ userDetails.phone } 
        <br></br>
        <span> {t("Current plan")}</span>    :{ details?.data?.subscription_name } 
        <br></br>

<div className="subscription-actions">
<button
className="Btn text-center btn-subscription"
  onClick={() =>
    isLibyad && canCancel
      ? 
         handleUnsubscribe()
        : handleSubscribe()
     
  }
>
  {isLibyad && canCancel
    ? 
       t("unsubscribe")
      : t("renewal")
    }
</button>

<button
  className="Btn text-center btn-subscription"
  onClick={handleChangePackageClick}
>
  {t("Change Package")}
</button>
</div>


            </Col>
      )}
            {!userDetails.created_at && (

          <Col xs={12} md={12} lg={12} className="mb-3">
            <h2 className="empty-cart">
              {t("No Subscription")}
            </h2>
          </Col>
            )}
<Modal
  show={isUnsubscribeModalOpen}
  onHide={() => setIsUnsubscribeModalOpen(false)}
  centered
>
 {/*  <Modal.Header closeButton>
    <Modal.Title>{t("Confirm Unsubscribe")}</Modal.Title>
  </Modal.Header> */}

  <Modal.Body>
    <p>{t("Are you sure you want to unsubscribe?")}</p>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setIsUnsubscribeModalOpen(false)}
    >
      {t("Cancel")}
    </Button>

    <Button
      variant="danger"
      onClick={confirmUnsubscribe}
      disabled={loading}
    >
      {loading ? t("Processing") : t("Confirm")}
    </Button>
  </Modal.Footer>
</Modal>

<Modal
  show={isOtpModalOpen}
  onHide={() => setIsOtpModalOpen(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>{t("EnteryourOTP")}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
   <input
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  maxLength={4}
  className="form-control"
  value={otp}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); 
    setOtp(value);
  }}
  placeholder={t("EnteryourOTP")}
/>

  </Modal.Body>

  <Modal.Footer>
    <Button
      onClick={verifyOtp}
      disabled={!otp || loading}
    >
      {loading ? t("Processing") : t("Confirm")}
    </Button>
  </Modal.Footer>
</Modal>

<Modal
  show={isChangePackageModalOpen}
  onHide={resetChangePackageModal}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>
      {changePackageStep === "list"
        ? t("Change Package")
        : t("EnteryourOTP")}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {changePackageStep === "list" ? (
      <>
        <p>{t("Select a package")}</p>
        {packagesLoading ? (
          <p>{t("Processing")}</p>
        ) : packages.length === 0 ? (
          <p>{t("No packages available")}</p>
        ) : (
          <Form.Select
            className="change-package-select"
            value={selectedPackageUuid}
            onChange={(e) => setSelectedPackageUuid(e.target.value)}
          >
            {packages.map((pkg) => {
              const uuid = pkg?.uuid || pkg?.id;
              return (
                <option key={uuid} value={uuid}>
                  {getPackageOptionLabel(pkg)}
                </option>
              );
            })}
          </Form.Select>
        )}
      </>
    ) : (
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={4}
        className="form-control"
        value={upgradeOtp}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, "");
          setUpgradeOtp(value);
        }}
        placeholder={t("EnteryourOTP")}
      />
    )}
  </Modal.Body>

  <Modal.Footer>
    {changePackageStep === "list" ? (
      <>
        <Button variant="secondary" onClick={resetChangePackageModal}>
          {t("Cancel")}
        </Button>
        <Button
          onClick={handlePackageUpgrade}
          disabled={!selectedPackageUuid || packagesLoading || loading}
        >
          {loading ? t("Processing") : t("Confirm")}
        </Button>
      </>
    ) : (
      <>
        <Button
          variant="secondary"
          onClick={() => {
            setChangePackageStep("list");
            setUpgradeOtp("");
          }}
        >
          {t("Cancel")}
        </Button>
        <Button
          onClick={handleUpgradeConfirm}
          disabled={!upgradeOtp || loading}
        >
          {loading ? t("Processing") : t("Confirm")}
        </Button>
      </>
    )}
  </Modal.Footer>
</Modal>


<LogoutConfirmationModal
           show={showModal}
           handleClose={handleCloseModal}
           handleConfirm={handleConfirmLogout}
   
      />
      </Row>
) : 
<Row className="my-3 wishlist">

      {userDetails.created_at && (

            <Col xs={12} md={12} lg={12} xxl={12} className="mb-3">
         <span>  {t("subscription date")}
            </span>  : { formattedDate}
            <br></br>
            <span>     {t("renewal date")} </span>: { userDetails?.renewal_date?? "-" } 
            <br></br>


      
        <span> {t("subscribed number")}</span>    :{ userDetails?.phone } 
        <br></br>


<button
className="Btn text-center"
  onClick={() =>
    handleLogoutClick() 
  }
>
  {t("unsubscribe")}
</button>


            </Col>
      )}
            {!userDetails.created_at && (

          <Col xs={12} md={12} lg={12} className="mb-3">
            <h2 className="empty-cart">
              {t("No Subscription")}
            </h2>
          </Col>
            )}
<Modal
  show={isUnsubscribeModalOpen}
  onHide={() => setIsUnsubscribeModalOpen(false)}
  centered
>
 {/*  <Modal.Header closeButton>
    <Modal.Title>{t("Confirm Unsubscribe")}</Modal.Title>
  </Modal.Header> */}

  <Modal.Body>
    <p>{t("Are you sure you want to unsubscribe?")}</p>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setIsUnsubscribeModalOpen(false)}
    >
      {t("Cancel")}
    </Button>

    <Button
      variant="danger"
      onClick={confirmUnsubscribe}
      disabled={loading}
    >
      {loading ? t("Processing") : t("Confirm")}
    </Button>
  </Modal.Footer>
</Modal>

<Modal
  show={isOtpModalOpen}
  onHide={() => setIsOtpModalOpen(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>{t("EnteryourOTP")}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
   <input
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
maxLength="4"
  className="form-control"
  value={otp}
                onKeyPress={allowOnlyNumbers}

  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); 
    setOtp(value);
  }}
  placeholder={t("EnteryourOTP")}
/>

  </Modal.Body>

  <Modal.Footer>
    <Button
      onClick={verifyOtp}
      disabled={!otp || loading}
    >
      {loading ? t("Processing") : t("Confirm")}
    </Button>
  </Modal.Footer>
</Modal>


<LogoutConfirmationModal
           show={showModal}
           handleClose={handleCloseModal}
           handleConfirm={handleConfirmLogout}
   
      />
      </Row>}
      
    </div>
    </div>
  );
};

export default Subscription;
